import React, { useState } from "react";
import axios from "axios";
import EmailValidator from "email-validator";
import { apiUrl } from "src/config/api";
import Headerpage from "src/components/header";
import Footerpage from "src/components/footer";
const ForgotPassword: React.FC = () => {
    const [email, setEmail] = useState("");
    // const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        // setError("");
        setLoading(true);
        const EmailValid = EmailValidator.validate(email.trim());
        if (EmailValid === false) {
            setLoading(false);
            alert("Please enter a valid email")

        }
        else if (EmailValid) {

            try {
                const response = await axios.post(apiUrl("/user/resetLink"), {
                    email
                });

                console.log("rrss", response)
                if (response.data?.status === true) {
                    alert(response?.data?.message);
                    window.location.href = "/";
                    localStorage.setItem("token", response.data.token); // Store token
                }else{
                    alert(response?.data?.message)
                }
            } catch (err: any) {
                // setError(err.response?.data?.message || "Reset password failed!");
                alert("Reset password failed!")
            } finally {
                setLoading(false);
            }
        }
    };


    return (
        <>
        <Headerpage/>
                <div className="container-inner">
                    <div className=" content-leader"
                        style={{
                            height:"calc(100vh - 153px)",
                            width: "100%",
                            backgroundImage: `-webkit-gradient(linear, left top, left bottom, from(rgba(62, 124, 177, 0.5)), to(rgba(62, 124, 177, 0.5))),url(${require('src/assets/homepage_img.jpg')})`,
                            backgroundPosition: 'center'
                        }}>
{/*          
                        <div className="welcome-back">
                            <div className="sign-In-back"> */}
                                {/* <h1 className="sign-in-head" style={{marginTop: "-5px"}}>Welcome to Grit Leadership!</h1> */}
                              
                                <div className="forgot-main-content">
            <h2 style={{ marginBottom: "20px", fontSize: "33px ", color: "rgba(0, 0, 94, 1)",textAlign:"center" }}>Forgot Password</h2>

            <form onSubmit={handleLogin} style={{
                display: "flex",
                flexDirection: "column",
                gap: "15px"
            }}>
                {/* {error && <p style={{ color: "red", fontWeight: "bold" }}>{error}</p>} */}

                <input
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required={true}
                    style={{
                        padding: "12px",
                        fontSize: "16px",
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        outline: "none"
                    }}
                />
                <button
                    type="submit"
                    disabled={loading}
                    style={{
                        padding: "12px",
                        fontSize: "17px",
                     fontWeight: 700,
                        backgroundColor: loading ? "#ccc" : "rgba(0, 0, 94, 1)",
                        color: "white",
                        border: "none",
                        borderRadius: "6px",
                        cursor: loading ? "not-allowed" : "pointer",
                        transition: "background 0.3s"
                    }}
                >
                    {loading ? "..." : "Send Link"}
                </button>
            </form>
        </div>

                                
                                
                            {/* </div>
                        </div> */}
        
                    </div>
        
                </div>
                <Footerpage/>
        
        
        
            </>
    );
};

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/pages/home/signIn-page/forgotPass.tsx